import React from 'react'
import { useNavigate } from 'react-router-dom'
import logonew from '../Images/logonew.png'

function Navbar() {
  const navigate = useNavigate();

  return (
    <div>
      <nav className="navbar navbar-expand-lg bg-body-tertiary" style={{ top: 0, padding: 0, color: 'black', zIndex: 1000 }}>
        <div className="container-fluid main_nav_body">

          {/* Toggle Button for Mobile View */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarTogglerDemo03"
            aria-controls="navbarTogglerDemo03"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon" />
          </button>

          {/* Logo */}
          <div className='col-auto'>
            <img
              src={logonew}
              className='navbar_logo'
              alt="Logo"
              onClick={() => navigate("/")}
            />
          </div>

          {/* Title */}
          <div className='col-auto text-center'>
            <p className='fs-5 fw-bold logo_head mt-2 ms-2' onClick={() => navigate("/")}>
              Vilvattam Service <br />Co-operative Bank LTD No: 337
            </p>
          </div>

          {/* Navigation Items */}
          <div className="collapse navbar-collapse" id="navbarTogglerDemo03">
            <ul className="navbar-nav ms-auto mb-2 mb-lg-0">
              <li className="nav-item">
                <a className="nav-link" onClick={() => navigate("/")}>Home</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" onClick={() => navigate("/error")}>About Us</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" onClick={() => navigate("/error")}>Loans</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" onClick={() => navigate("/error")}>Our Management</a>
              </li>
              <li className="nav-item">
                <a className="nav-link" onClick={() => navigate("/error")}>Contact Us</a>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </div>
  )
}

export default Navbar;
